import { useId } from 'react';
import { cn } from '@/lib/utils';

/**
 * 0~5 별점 (0.5 단위 지원).
 * SVG path 절반 채우기로 half-star 표현.
 */
export function OpportunityStars({
  value,
  max = 5,
  showLabel = true,
  className,
}: {
  value: number;
  max?: number;
  showLabel?: boolean;
  className?: string;
}) {
  // 0.5 단위 반올림
  const clamped = Math.max(0, Math.min(max, value));
  const rounded = Math.round(clamped * 2) / 2;

  return (
    <div className={cn('space-y-2', className)}>
      <div className="flex items-end justify-between">
        <div className="text-xs uppercase tracking-widest text-gray-400">기회점수</div>
        <div className="text-xs font-bold text-gold">★ Opportunity</div>
      </div>
      <div className="flex items-baseline gap-2">
        <span className="tabular text-3xl font-extrabold text-white">{clamped.toFixed(2)}</span>
        <span className="text-gray-500">/ {max}</span>
      </div>
      <div className="flex items-center gap-1">
        {Array.from({ length: max }).map((_, i) => {
          const fill = rounded - i;
          return <Star key={i} index={i} fillRatio={fill <= 0 ? 0 : fill >= 1 ? 1 : 0.5} />;
        })}
      </div>
    </div>
  );
}

function Star({ index, fillRatio }: { index: number; fillRatio: 0 | 0.5 | 1 }) {
  const base = useId();
  const id = `${base}-star-${index}`;
  return (
    <svg viewBox="0 0 24 24" width={22} height={22} aria-hidden="true">
      <defs>
        <linearGradient id={id}>
          <stop offset={`${fillRatio * 100}%`} stopColor="#FFD700" />
          <stop offset={`${fillRatio * 100}%`} stopColor="#374151" />
        </linearGradient>
      </defs>
      <path
        d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
        fill={`url(#${id})`}
      />
    </svg>
  );
}
